import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/main.css'
import { i18n } from './i18n'
import { VueReCaptcha } from 'vue-recaptcha-v3'

const app = createApp(App)
app.use(VueReCaptcha, {
  siteKey: '6LdMLVEqAAAAAIA_zmmW00tl5eBQrHG4g670Nt0G',
  loaderOptions: {
    autoHideBadge: true
  }
})
app.use(router)
app.use(i18n)
app.mount('#app')
